import axios from 'axios';

const loadAbort = () => {
    return new AbortController();
};

export const updateInternalUserRolesEndpoint = (token: string, userId: string, roleId: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/internal-users/${userId}/assign-role/internal`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    role_id: roleId,
                },
            }),
        controller,
    };
}

export const getInternalUserAssignedRolesEndpoint = (token: string, userId: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/user/v1/admin/internal-user/${userId}/assigned-roles`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const removeInternalUserRoleEndpoint = (token: string, userId: string, roleId: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'delete',
                url: `${urlService}/user/v1/admin/internal-users/${userId}/assigned-role`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    role_id: roleId,
                },
            }),
        controller,
    };
}

